import { createAsyncThunk } from "@reduxjs/toolkit";
import request from "../../../../service";

import {
    deletedRestoreYears,
    deletedYear,
    setAcademicYear,
    setYearsRestoreData,
    updateYear,
} from "./academicYearSlice";
import { IErrorResponse, IRootState } from "../../../../types";
import { IAcademicYearCreate, IAcademicYearPayload } from "../types";

const SetAcademicYear = createAsyncThunk(
    "create/academic/year",
    async (data: IAcademicYearCreate, { rejectWithValue }) => {
        try {
            const response = await request.post("/academic-years", data);

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;

            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const GetAcademicYears = createAsyncThunk("get/academic/years", async (_, { dispatch, rejectWithValue, getState }) => {
    try {
        const response = await request.get("/academic-years");
        const lang = getState() as IRootState;
        const defaultLanguage = lang.languages.defaultLanguage;
        dispatch(setAcademicYear({ data: response.data, defaultLanguage }));

        return response.data;
    } catch (error) {
        const typedError = error as IErrorResponse;
        return rejectWithValue(typedError.response.data.message || "unexpected_fail");
    }
});

const DeleteAcademicYear = createAsyncThunk(
    "delete/academic/year",
    async (id: number, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.delete(`/academic-years/${id}`);

            dispatch(deletedYear(id));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const EditAcademicYear = createAsyncThunk(
    "edit/academic/year",
    async (data: IAcademicYearPayload, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.put(`/academic-years/${data.id}`, data);
            dispatch(updateYear(response.data));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const GetDeleteYears = createAsyncThunk("get/delete/years", async (_, { dispatch, rejectWithValue }) => {
    try {
        const response = await request.get(`/academic-years/deleted-items`);

        dispatch(setYearsRestoreData(response.data));

        return response.data;
    } catch (error) {
        const typedError = error as IErrorResponse;
        return rejectWithValue(typedError.response.data.message || "unexpected_fail");
    }
});

const RestoreDeleteYears = createAsyncThunk(
    "restore/delete/years",
    async (id: number, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.post(`/academic-years/restore/${id}`);

            dispatch(deletedRestoreYears(id));

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

export { GetAcademicYears, DeleteAcademicYear, EditAcademicYear, SetAcademicYear, RestoreDeleteYears, GetDeleteYears };
